import DBObject from "../utils/DBObject";
import CloneContext from "../utils/CloneContext";

export default class SignUpRequest extends DBObject {
  private static readonly _EMAIL: number = 0;
  public id: number = 0;
  public otherMaster: DBObject;
  private _email: string = "";
  public constructor(d3eParams?: Partial<{ email: string }>) {
    super();

    this.setEmail(d3eParams?.email ?? "");
  }
  public get d3eType(): string {
    return "SignUpRequest";
  }
  public clear(): void {
    this.d3eChanges.clear();
  }
  public get email(): string {
    return this._email;
  }
  public setEmail(val: string): void {
    let isValChanged: boolean = this._email !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(SignUpRequest._EMAIL, this._email);

    this._email = val;

    this.fire("email", this);
  }
  public get(field: number): any {
    switch (field) {
      case SignUpRequest._EMAIL: {
        return this._email;
      }
      default: {
        return null;
      }
    }
  }
  public updateD3EChanges(index: number, value: any): void {
    if (this.lockedChanges()) {
      return;
    }

    super.updateD3EChanges(index, value);
  }
  public restore(): void {
    /*
TODO: Might be removed
*/

    this.d3eChanges.restore(this);
  }
  public deepClone(clearId = true): SignUpRequest {
    let ctx: CloneContext = new CloneContext({ "clearId": clearId });

    return ctx.startClone(this);
  }
  public collectChildValues(ctx: CloneContext): void {}
  public deepCloneIntoObj(dbObj: DBObject, ctx: CloneContext): void {
    let obj: SignUpRequest = dbObj as SignUpRequest;

    obj.id = this.id;

    obj.setEmail(this._email);
  }
  public set(field: number, value: any): void {
    switch (field) {
      case SignUpRequest._EMAIL: {
        this.setEmail(value as string);
        break;
      }
    }
  }
}
